export const CLIENT_DEFAULT_COLUMN_STATE = [
	{
		colId: 'HARMONIZED_VENDOR_NAME',
		hide: false,
		width: 287,
	},
	{
		colId: 'PARENT_LEGAL_ENTITY',
		hide: false,
	},
	{
		colId: 'PO_BASE_SPEND',
		hide: false,
	},
	{
		colId: 'Custom_L1Category',
		hide: false,
	},
	{
		colId: 'Custom_L2Category',
		hide: false,
	},
	{
		colId: 'Custom_L3Category',
		hide: false,
	},
	{
		colId: 'Custom_L4Category',
		hide: false,
	},
	{
		colId: 'SPEND_TYPE',
		hide: false,
	},
	{
		colId: 'ID',
		hide: true,
		width: 100,
	},
	{
		colId: 'VENDOR_NAME',
		hide: true,
	},
	{
		colId: 'ADDRESSABLE',
		hide: true,
		width: 141,
	},
	{
		colId: 'HARMONIZED_VENDOR_ID',
		hide: true,
	},
];

export const AP_DEFAULT_COLUMN_STATE = [
	{
		colId: 'HARMONIZED_VENDOR_NAME',
		hide: false,
		width: 287,
	},
	{
		colId: 'PO_BASE_SPEND',
		hide: false,
	},
	{
		colId: 'AP_L1Category',
		hide: false,
	},
	{
		colId: 'AP_L2Category',
		hide: false,
	},
	{
		colId: 'AP_L3Category',
		hide: false,
	},
	{
		colId: 'AP_L4Category',
		hide: false,
	},
	{
		colId: 'SPEND_TYPE',
		hide: false,
	},
	{
		colId: 'ID',
		hide: true,
		width: 100,
	},
	{
		colId: 'VENDOR_NAME',
		hide: true,
	},
	{
		colId: 'ADDRESSABLE',
		hide: true,
		width: 141,
	},
	{
		colId: 'HARMONIZED_VENDOR_ID',
		hide: true,
	},
];
